import { OnErrorInterceptor, RequestContext } from "modules/graphql-fetch";

/* new Date() instead performance.now() for support node & browser both */

export const startRequestMetrics = (context: RequestContext) => {
  context.metrics = { start: +new Date() };
};

export const endRequestMetrics = (context: RequestContext) => {
  if (!context.metrics?.start) return;
  const time = +new Date() - context.metrics.start;
  console.log(
    `[Metrics][Graphql] Operation ${context.operationName} took ${time}ms to complete`
  );
};

export const onAuthError: OnErrorInterceptor = (error, context, response) => {
  if (error && response.status === 401) {
    /* todo: add logout behavior after return to jwt auth */
  }
};
